module.exports = __webpack_public_path__ + "static/media/language.1758a2c8.svg";